import AFFILIATE from '../../assets/images/affiliate.svg'
import DASHBOARD from '../../assets/images/dashboard.svg'
import SIDEBAR_HELP from '../../assets/images/sidebar_help.svg'
import SWAP from '../../assets/images/swap.svg'
import TRANSACTIONS from '../../assets/images/transactions.svg'

const HEADER_TAB_ARRAY = [
	{
		id: 1,
		name: 'Dashboard',
		image: DASHBOARD,
		to: '/dashboard',
	},
	{
		id: 2,
		name: 'Transactions',
		image: TRANSACTIONS,
		to: '/transactions',
	},
	// {
	// 	id: 3,
	// 	name: 'Borrow',
	// 	image: BORROW,
	// 	to: '/borrow',
	// },
	{
		id: 4,
		name: 'Swap',
		image: SWAP,
		to: '/swap',
	},
	{
		id: 5,
		name: 'Affiliate',
		image: AFFILIATE,
		to: '/affiliate',
		role: 'user',
	},
	{
		id: 6,
		name: 'Help',
		image: SIDEBAR_HELP,
		to: '/help',
	},
]

export default HEADER_TAB_ARRAY
